module.exports = "../../../../platform/assets/pageMainIcon/icon-tongyong-1-yellow.svg";